"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtlWebVitalsInstrumentation = exports.registerCustomWebVitalMetric = void 0;
const instrumentation_1 = require("@opentelemetry/instrumentation");
const web_vitals_1 = require("web-vitals");
const api_1 = require("@opentelemetry/api");
const shared_1 = require("../shared");
const INSTRUMENTATION_NAME = 'rtl-web-vitals';
/**
 * Register custom web-vitals metrics as a span
 * @param metric
 */
function registerCustomWebVitalMetric(metric) {
    if (metric.label === 'custom') {
        const tracer = api_1.trace.getTracer(INSTRUMENTATION_NAME);
        const span = tracer.startSpan(metric.name);
        (0, shared_1.endSpanWithDurationFromMilliseconds)(span, metric.value);
    }
}
exports.registerCustomWebVitalMetric = registerCustomWebVitalMetric;
class RtlWebVitalsInstrumentation extends instrumentation_1.InstrumentationBase {
    constructor(version) {
        super(INSTRUMENTATION_NAME, version, { enabled: true });
    }
    init() { }
    enable() {
        const tracer = api_1.trace.getTracer(INSTRUMENTATION_NAME);
        (0, web_vitals_1.onCLS)((metric) => {
            const span = tracer.startSpan('CLS');
            (0, shared_1.endSpanWithDurationFromMilliseconds)(span, metric.value);
        });
        (0, web_vitals_1.onLCP)((metric) => {
            const span = tracer.startSpan('LCP');
            (0, shared_1.endSpanWithDurationFromMilliseconds)(span, metric.value);
        });
        (0, web_vitals_1.onFID)((metric) => {
            const span = tracer.startSpan('FID');
            (0, shared_1.endSpanWithDurationFromMilliseconds)(span, metric.value);
        });
        (0, web_vitals_1.onFCP)((metric) => {
            const span = tracer.startSpan('FCP');
            (0, shared_1.endSpanWithDurationFromMilliseconds)(span, metric.value);
        });
        (0, web_vitals_1.onTTFB)((metric) => {
            const span = tracer.startSpan('TTFB');
            (0, shared_1.endSpanWithDurationFromMilliseconds)(span, metric.value);
        });
        (0, web_vitals_1.onINP)((metric) => {
            const span = tracer.startSpan('INP');
            (0, shared_1.endSpanWithDurationFromMilliseconds)(span, metric.value);
        });
    }
}
exports.RtlWebVitalsInstrumentation = RtlWebVitalsInstrumentation;
